import {
  SegmentController,
  SegmentOption,
} from "components/designV2/segmentcontroller/segmentcontroller";
import { TabsWrapper } from "components/designV2/generalStyles";
import React, { useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import { useCompanyStore } from "web-apps/company/stores/companyStore/companyStore";
import { AGIOverview } from "./agiOverview.component";
import { IndividualSalary } from "./individualSalary.component";
import { MonthlySalary } from "./montlySalary/monthlySalary.component";
import { MonthOverview } from "./montlySalary/monthOverview.component";
import { SalaryExportsOverview } from "./salaryExports.component";

type SalaryTabKey =
  | "MonthOverview"
  | "Monthly"
  | "Individual"
  | "AGI"
  | "Exports";

export const SalaryTabs: React.FC = () => {
  const [currentTab, setCurrentTab] = useState<SalaryTabKey>("MonthOverview");
  const { t } = useTranslation();
  const [companyState] = useCompanyStore();

  const haveSalaryModule = useMemo(() => {
    return (
      companyState.companySettings.find(
        (s) => s.key === "EnableCompanySalaryView",
      )?.value === "true"
    );
  }, [companyState.companySettings]);

  const options = useMemo<SegmentOption<SalaryTabKey>[]>(() => {
    const base: SegmentOption<SalaryTabKey>[] = [
      { value: "MonthOverview", label: t("Salary.Salaries") },
    ];
    if (haveSalaryModule) {
      base.push(
        { value: "Monthly", label: t("Salary.MonthlySalary") },
        { value: "Individual", label: t("Salary.IndividualSalary") },
        { value: "AGI", label: t("Salary.AGI") },
      );
    } else {
      base.push({ value: "Exports", label: t("Salary.SalaryExports") });
    }
    return base;
  }, [haveSalaryModule, t]);

  return (
    <>
      <TabsWrapper>
        <SegmentController
          options={options}
          value={currentTab}
          onChange={setCurrentTab}
        />
      </TabsWrapper>
      {currentTab === "MonthOverview" && <MonthOverview />}
      {currentTab === "Monthly" && <MonthlySalary />}
      {currentTab === "Individual" && <IndividualSalary />}
      {currentTab === "AGI" && <AGIOverview />}
      {currentTab === "Exports" && <SalaryExportsOverview />}
    </>
  );
};

